import get from 'lodash/get';
import groupBy from 'lodash/groupBy';
import { camelizeKeys } from 'humps';
import getSplashApiClient from 'lib/SplashApiClient/singleton';

/**
 * Form Renderer v2 is the custom CMS form, composed of CmsComponents.
 * This is the API client that it uses.
 */
export default class FormRendererV2ApiClient {
    /**
     * @param {SplashApiClient} apiClient
     */
    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    /**
     *
     * @param {string} eventId
     */
    getRemainigResponses(eventId) {
        return this.apiClient
            .get(`/form-submission/response/limits/event/${eventId}`)
            .then(this.formatRemainigResponsesAsValueToAvailability);
    }

    /**
     *
     * @param  {Object} response - eg:
     * { data: {
     *      limits: [
     *          { node_id: 169, abcq_id: 4, value: "One", available: 19 },
     *          ...
     *      ],
     * }}
     * @return {Object} - response limits grouped by question id. Camelized keys.
     */
    formatRemainigResponsesAsValueToAvailability(response) {
        const limits = get(response, 'data.limits', []).filter((descriptor) => descriptor.available !== undefined);

        return camelizeKeys(groupBy(limits, 'abcq_id'));
    }
}

export const getFormRendererV2ApiClient = () => new FormRendererV2ApiClient(getSplashApiClient());
